import { render, staticRenderFns } from "./kaijiqingkuang.vue?vue&type=template&id=95f8d088&scoped=true&"
import script from "./kaijiqingkuang.vue?vue&type=script&lang=js&"
export * from "./kaijiqingkuang.vue?vue&type=script&lang=js&"
import style0 from "./kaijiqingkuang.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./kaijiqingkuang.vue?vue&type=style&index=1&id=95f8d088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f8d088",
  null
  
)

export default component.exports